"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ApsClient = void 0;
const ApsService_1 = require("./ApsService");
const Logger_1 = require("./Logger");
const ResiliencyConfiguration_1 = require("./ResiliencyConfiguration");
class ApsClient {
    constructor(resiliencyConfig) {
        this.resiliencyConfig = new ResiliencyConfiguration_1.ResiliencyConfiguration();
        this.logger = new Logger_1.Logger();
        this.resiliencyConfig = resiliencyConfig;
        this._apsService = new ApsService_1.ApsService(this.resiliencyConfig);
        this.logger.logInfo(`Initializing resiliency config:  ${this.resiliencyConfig}`);
    }
    get apsService() {
        return this._apsService;
    }
}
exports.ApsClient = ApsClient;
